// components/analysis/generic/TableLoader.jsx
'use client';

const TableLoader = ({ children, loading }) => {
  if (loading) {
    return (
      <div className="border-b border-[var(--q3-stroke-light)]">
        <div className="flex justify-center items-center p-8">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[var(--q3-primary-default)]"></div>
        </div>
      </div>
    );
  }

  return children;
};

export default TableLoader;
